/*
* 上报地点IP 页面路径枚举（顶层路由，与 /pda 并列）
*/
export enum ReportIpPath {
    // 上报地点IP - 登录页
    REPORT_IP_LOGIN = "/report-ip/login",
    // 上报地点IP - 上报页
    REPORT_IP = "/report-ip",
}
